/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'
import PropTypes from 'prop-types'

const CartTitle = ({giftCardCount}) => {
    const {
        derivedData: {totalItems}
    } = useCurrentBasket()
    return (
        <Text
            sx={{
                m: 0,
                fontFamily: fonts.primary,
                fontSize: {base: pxToRem(22), md: pxToRem(30)},
                fontWeight: 600,
                letterSpacing: pxToRem(4),
                color: 'black',
                lineHeight: 'normal',
                textTransform: 'uppercase',
                mx: {base: pxToRem(11), md: 0},
                mb: {base: pxToRem(30), md: pxToRem(25)}
            }}
        >
            <FormattedMessage
                defaultMessage="Your Cart ({itemCount, plural, =0 {0 items} one {# item} other {# items}})"
                values={{itemCount: totalItems + giftCardCount}}
                id="cart_title.title"
            />
        </Text>
    )
}

CartTitle.propTypes = {
    giftCardCount: PropTypes.number
}

export default CartTitle
